export default __webpack_public_path__ + "static/media/avatar-5.9f668205.png";